import React from 'react';
import Select from 'react-select';
import FieldInput from '../../../../_common/components/FieldInput';
import {toAbsoluteUrl} from '../../../../../../_metronic/_helpers';
import ButtonAction from '../../../../_common/components/ButtonAction';
import {floatValue, integerValue} from '../../../../../../utils/format';
import {optionsVatType} from '../../../constants/options';
import {createDocumentGridSelectStyles} from '../../../../_common/selectStyles/customSelectStyles';
import styles from '../styles.module.scss';

const RowCommonDocs = ({
                         fieldsSet,
                         values,
                         removeRow,
                         index,
                         setFieldValue
                       }) => {
  return (
    <div className={styles.commonDocsRowContainer}>
      <Select
        name={fieldsSet.vatType}
        value={values.rowsCommonDocs[index].vatType}
        options={optionsVatType}
        styles={createDocumentGridSelectStyles}
        placeholder={''}
        onChange={value => setFieldValue(`rowsCommonDocs[${index}].vatType`, value)}
      />
      <FieldInput fieldId={fieldsSet.description}/>
      <FieldInput fieldId={fieldsSet.quantity} onChange={integerValue}/>
      <FieldInput fieldId={fieldsSet.price} onChange={floatValue}/>
      <div className={'mr-4 w-50px ml-auto'}>
        {index !== 0 &&
        (
          <ButtonAction
            variant={'icon'}
            iconButtonType={'error'}
            onClick={removeRow}
            label={<img src={toAbsoluteUrl('/media/common/Delete_red.svg')} alt="delete"/>}
            customClassnames={'mr-4 ml-auto'}
            avoidDoubleClick={false}
          />
        )}
      </div>
    </div>
  );
};

export default RowCommonDocs;